import { Endpoint } from "../../../../constant/Endpoint"
import { Environment } from "../../../../constant/Environment"
import { apiService } from "../../../../infrastructure/apiService"

const { TRAVELER_ENDPOINT, COMMON_ENDPOINT } = Environment
const { FNC1A_Notifications, FNC9_Update_Login_History } = Endpoint

export const homeApi = {
  notifications: () =>
    apiService({
      data: {},
      method: "GET",
      url: `${TRAVELER_ENDPOINT}${FNC1A_Notifications}`,
    }),
  updateLoginHistory: (data: { travelerId: string; loginTime: string }) =>
    apiService({
      data: data,
      method: "PUT",
      url: `${COMMON_ENDPOINT}${FNC9_Update_Login_History}`,
    }),
}
